const contractsRoutes = [
  {
    path: "/contracts",
    name: "contracts",
    component: () =>
      import(
        /* webpackChunkName: "contracts" */ "../components/contracts/Contracts.vue"
      ),
  },
  {
    path: "/contracts/doctor/:doctorId/services",
    name: "doctor-services",
    component: () =>
      import(
        /* webpackChunkName: "contracts" */ "../components/contracts/DoctorServices.vue"
      ),
  },
];

export default contractsRoutes;
